export const hostersApiEndpoints = {
  getHosters: (event: string, page: number, limit: number) =>
    `/pro-users?event=${event}&page=${page}&limit=${limit}`,
  getHosterById: (id: string, event: string) =>
    `/pro-users/${id}?event=${event}`,
  updateHoster: (id: string, event: string) =>
    `/pro-users/${id}?event=${event}`,
  suspendHoster: (id: string, event: string) =>
    `/pro-users/${id}/suspend?event=${event}`,
  reactivateHoster: (id: string, event: string) =>
    `/pro-users/${id}/reactivate?event=${event}`,
};
